import FemaleRewardSlider from "@/components/FemaleRewardsSlider";
import MaleRewardSlider from "@/components/MaleRewardsSlider";
import CopyReferralCode from "@/components/onboarding/CopyReferralCode";
import ReferralSpotCountdown from "@/components/ReferralSpotCountdown";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useStandaloneMode } from "@/hooks/useStandaloneMode";
import { useTranslation } from "@/hooks/useTranslation";
import { ChevronLeftIcon } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import moneybag from "@/assets/money_bag.png";

export default function ReferralProgram() {
  const isStandalone = useStandaloneMode();
  const t = useTranslation();
  const navigate = useNavigate();
  const [activeGender, setActiveGender] = useState("male");

  const handleBackClick = () => {
    navigate(-1);
  };

  function MaleRewards() {
    return (
      <div className="space-y-4 bg-zinc-900 rounded-3xl p-6">
        <MaleRewardSlider />
        <div className="text-sm font-bold">
          {t.REFERRAL_PAGE.LABELS.MALE_REWARD}
        </div>
        <div className="flex flex-row text-sm text-zinc-400">
          {t.REFERRAL_PAGE.LABELS.MALE_EXPIRY_DATE_TITLE}:{" "}
          {t.REFERRAL_PAGE.LABELS.MALE_EXPIRY_DATE}
        </div>
      </div>
    );
  }

  function FemaleRewards() {
    return (
      <div className="space-y-4 bg-zinc-900 rounded-3xl p-6">
        <FemaleRewardSlider />
        <div className="text-sm font-bold">
          {t.REFERRAL_PAGE.LABELS.FEMALE_REWARD}
        </div>
        <div className="flex flex-row text-sm text-zinc-400 gap-4 items-center">
          {t.REFERRAL_PAGE.LABELS.FEMALE_REMAINING_REWARDS_TITLE}
          <ReferralSpotCountdown />
        </div>
      </div>
    );
  }

  return (
    <div
      className={`dark px-4 max-w-xl mx-auto space-y-4 ${
        isStandalone ? "mb-24" : "mb-16"
      }`}
    >
      <Button className="dark pl-1" variant="ghost" onClick={handleBackClick}>
        <ChevronLeftIcon className="mr-1 h-4 w-4" />
        {t.SHARED.LABELS.BACK_BUTTON}
      </Button>
      <h1 className="text-2xl font-semibold mb-2 mt-8 flex flex-row items-center">
        {t.REFERRAL_PAGE.LABELS.TITLE}
        <img src={moneybag} className="w-6 h-6 ml-1" />
      </h1>
      <div className="text-sm text-gray-400">
        {t.REFERRAL_PAGE.LABELS.SHARE_YOUR_CODE}
      </div>
      <CopyReferralCode />

      <Tabs
        value={activeGender}
        onValueChange={setActiveGender}
        className="w-full"
      >
        <TabsList className="w-full md:w-fit grid grid-cols-2 mb-5">
          <TabsTrigger value="male">
            {t.REFERRAL_PAGE.LABELS.MALE_REFERRAL}
          </TabsTrigger>
          <TabsTrigger value="female">
            {t.REFERRAL_PAGE.LABELS.FEMALE_REFERRAL}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="male">
          <MaleRewards />
        </TabsContent>
        <TabsContent value="female">
          <FemaleRewards />
        </TabsContent>
      </Tabs>

      <div className="space-y-2">
        <div className="text-lg font-semibold">
          {t.REFERRAL_PAGE.LABELS.CLAIMING_TITLE}
        </div>
        <div className="text-sm text-gray-400">
          {t.REFERRAL_PAGE.LABELS.CLAIMING_INSTRUCTIONS}
        </div>
      </div>
    </div>
  );
}
